package org.moxultimate.topwithmox.product.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * ProductContentResponse
 * Top-level item returned by GET /product-contents.
 * Each content groups a set of ranked products under a review title and video link.
 *
 * @param id Cursor ID used for pagination (pass as beforeId in the next request).
 * @param title Section heading shown in ProductsHeading (e.g. "Best Gaming Mouse 2026").
 * @param description Short paragraph shown below the title.
 * @param videoLink YouTube or external link for the "Full Video Review" button.
 * @param tags Pipe-separated tag string used for client-side chip filtering (e.g. "Gaming | Mouse | Budget").
 * @param products Ordered list of ranked products belonging to this content.
 */
@Serializable
data class ProductContentResponse(
    @SerialName("id") val id: Long,
    @SerialName("title") val title: String,
    @SerialName("description") val description: String? = null,
    @SerialName("videoLink") val videoLink: String? = null,
    @SerialName("thumbnailPath") val thumbnailPath: String? = null,
    @SerialName("tags") val tags: String? = null,
    @SerialName("type") val type: String? = null,
    @SerialName("createdAt") val createdAt: String? = null,
    @SerialName("products") val products: List<ProductResponse> = emptyList(),
)
